import React from 'react';
import LmsLookupDefinitionsPage from '../lookup-definitions/LmsLookupDefinitionsPage';

// Eğitim Tipi Tanımları ekranında silme işlevi kaldırıldı — talep üzerine geçici olarak
// kapatıldı, `allowDelete={false}` ile kontrol ediliyor (bkz. LmsLookupDefinitionsPage).
const TrainingTypeDefinitions = () => <LmsLookupDefinitionsPage groupCode="TRAINING_TYPES" pageTitleKey="trainingTypeDefinitions.title" allowDelete={false} />;

export default TrainingTypeDefinitions;
